import { createGlobalStyle } from 'styled-components';
import { Optimize } from './optimize';
import { Fonts } from './fonts';
import { fontFamilyVariables } from './variables';

/* eslint-disable */
export const GlobalStyle = createGlobalStyle`

  ${Optimize}
  ${Fonts}
  body {
    font-family: ${fontFamilyVariables.din_regular}, Verdana, sans-serif;
    //background-color: red;
  }
  
  #root {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100vh;
    //background-color: red;
  }

  video {
    height: 100%;
    width: 100%;
  }
  
  .FontsLoaded {
    body {
      font-family: ${fontFamilyVariables.din_regular}, Verdana, sans-serif
    }
  }
  
  .FontsLoading {
    body {
      visibility: hidden
    }
  }
  
  .FontsLoaded,
  .FontsFailed {
    body {
      visibility: visible
    }
  }
  
  * {
    &::-webkit-media-controls-panel,
    &::-webkit-media-controls-play-button,
    &::-webkit-media-controls-start-playback-button {
      display: none!important;
      -webkit-appearance: none;
    }
  }
`;
